
module.exports = {
    SET_CARTO_BACKGROUND: 'SET_CARTO_BACKGROUND',
    CARTO_BACKGROUND: 'CARTO_BACKGROUND',
    LAYERS_ORDER: 'LAYERS_ORDER',
    homeListOfSelectedStations: 'homeListOfSelectedStations',
    homeListOfSelectedLayers: 'homeListOfSelectedLayers',
    homeListOfLayersOpacity: 'homeListOfLayersOpacity',
    homeSelectedBackground: 'homeSelectedBackground',
    MAP_BACKGROUNDS_TO_HIDE: 'mapBackgroundsToHide',
    DEFAULT_MAP_BACKGROUND: 'defaultMapBackground',
    linkContributorsDepartments: 'linkContributorsDepartments',
    TAXON_MAP: {
        PRESENCE_MISSING: '1',
        ABUNDANCE: '2',
        OCCURENCE_FREQUENCY: '3',
    },
    DEFAULT_LAYERS_SHOWN: [
        'GRID_',
        'TOWN',
        'AAC_SANDRE',
        'AAC_UPLOADED',
        'WATERMASS',
        'STATION_WATERSHED',
        'STATION_WATERSHED_1',
        'STATION_WATERSHED_2',
        'STATION_WATERSHED_3',
        'STATION_WATERSHED_4',
    ],
}